// Pathify
import Vue from 'vue'
import { dispatch, make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'

Vue.use(router)

// Data
const state = {
  loading: false,
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  init: async () => {
  },
  export (context, payload) {
    console.log(payload)
    state.loading = true
    return new Promise((resolve, reject) => {
      axios.post('/api/export', payload, { responseType: 'blob' })
        .then((response) => {
          console.log(response)
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', payload.sourceType + '.' + payload.type)
          document.body.appendChild(fileLink)
          fileLink.click()
          state.loading = false
        }).catch(error => {
          dispatch('alert/setSnackbar', { text: error, type: 'error' })
          reject(error)
        state.loading = false
        })
    })
  },
  document (context, payload) {
    console.log(payload)
    state.loading = true
    return new Promise((resolve, reject) => {
      var url = '/api/storage/document/' + payload.id
      if (payload.version != null) {
        url += '/' + payload.version
      }
      axios.get(url, { responseType: 'blob' })
        .then((response) => {
          // console.log('Headerline:')
          var headerLine = response.headers['content-disposition']
          var startFileNameIndex = headerLine.indexOf('"') + 1
          var endFileNameIndex = headerLine.lastIndexOf('"')
          var filename = headerLine.substring(startFileNameIndex, endFileNameIndex)

          var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf', filename: filename }))
          // window.open(fileURL, '_blank')
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          // fileLink.setAttribute('download', filename)
          fileLink.setAttribute('target', '_blank')
          // document.body.appendChild(fileLink)
          fileLink.click()
          state.loading = false
        }).catch(error => {
        dispatch('alert/setSnackbar', { text: error, type: 'error' })
        reject(error)
        state.loading = false
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
